import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { EditNewVesselOverrides } from './model';
import { ToggleableMeasurementView } from 'portcall/toggleablemeasurement/view';
import { ToggleButton } from 'portcall/togglebutton/view';

export const EditNewVesselOverridesView = SuperCritical(({ model: { 
        Overrides: ov, 
        ReadOnly, 
        ToggleableReadOnlyLength, 
        ToggleableOverrideLength,
        ToggleableReadOnlyBeam, 
        ToggleableOverrideBeam,
        ToggleableReadOnlyMaxDraft,
        ToggleableOverrideMaxDraft,
        UomInFeet,
        Countries,
        Cancel
    } } : { model : EditNewVesselOverrides }) =>
        <div className="vessel-info reserve-manual">
            <div className="explanatory-text">
                <span>Enter the vessel’s particulars. You need to enter the name, gross tonnage, beam, length, and one identifier, such as IMO.</span>
            </div>
            <div className="manual-back">
                {/* DC 5/2/2017 -- Optimized version will return to the previous lookup / search modal 
                                   Current version prevents returning to the previous lookup / search */}
                <a href="#" onClick={noDefault(Cancel)}>Back to search</a>
            </div>
            <div className="identifier-left-container">
                <div className="reserve-manual-row name">
                    <span className="pc-text-smalllabel reserve-manual-label name-label"> Name </span>    
                    { ReadOnly().Name
                      ? <input type="text" value={ReadOnly().Name} disabled={true} />
                      : <input type="text" value={ov.Name() || ''} onChange={e => ov.Name(e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row imo">
                    <span className="pc-text-smalllabel reserve-manual-label imo-label"> IMO </span>    
                    { ReadOnly().IMO
                     ? <input type="text" value={ReadOnly().IMO} disabled={true} />
                     : <input type="text" value={ov.IMO() || ''} onChange={e => ov.IMO(e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row mmsid">
                    <span className="pc-text-smalllabel reserve-manual-label mmsid-label"> MMSID </span>   
                    { ReadOnly().MMSID 
                      ? <input type="text" value={ReadOnly().MMSID} disabled={true} />
                      : <input type="text" value={ov.MMSID() || ''} onChange={e => ov.MMSID(e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row callsign">
                    <span className="pc-text-smalllabel reserve-manual-label callsign-label"> Call Sign </span>   
                    { ReadOnly().CallSign 
                      ? <input type="text" value={ReadOnly().CallSign} disabled={true} />
                      : <input type="text" value={ov.CallSign() || ''} onChange={e => ov.CallSign(e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row vin">
                    <span className="pc-text-smalllabel reserve-manual-label vin-label"> VIN </span>    
                    { ReadOnly().VIN 
                      ? <input type="text" value={ReadOnly().VIN} disabled={true} />
                      : <input type="text" value={ov.VIN() || ''} onChange={e => ov.VIN(e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row flag">
                    <span className="pc-text-smalllabel reserve-manual-label flag-label"> Flag </span>
                    <span>  
                    {/* Possible that readONly={true} is not needed.  disabled may be all we need. */}
                    { ReadOnly().VesselFlagId !== undefined
                        ? <select className="pc-select country_dropdown" disabled
                                value={ReadOnly().VesselFlagId} >
                                {Countries().map(c => <option key={c.Id()} value={c.Id()}>{c.Name()}</option>)}
                            </select>
                        : <select className="pc-select country_dropdown" 
                                value={ov.FlagId() === null ? '' : '' + ov.FlagId()} 
                                onChange={e => ov.FlagId(e.currentTarget.value === '' ? null : +e.currentTarget.value)}>
                                <option value="">--</option>
                                {Countries().map(c => <option key={c.Id()} value={c.Id()}>{c.Name()}</option>)}
                            </select>}
                        <span className="pc-select-chevron"></span>
                    </span>
                </div>
                {/* TODO DC 04/19/2017 -- Needed?
                <div className="save-button">
                    <button type="button" className="pc-button" onClick={model.Save} disabled={!model.CanSave()}>Save</button>
                </div>
                */}
            </div>
            <div className="identifier-right-container">
                <div className="reserve-manual-row vessel-type">
                    <span className="pc-text-smalllabel reserve-manual-label vessel-type-label">Vessel Type</span>
                    <span>
                        {ReadOnly().VesselType ?
                            <input type="text" value={ReadOnly().VesselType} disabled={true} /> :
                            <input type="text" value={ov.VesselType() || ''} onChange={e => ov.VesselType(e.currentTarget.value)} />
                        }
                    </span>
                </div>
                <div className="reserve-manual-row gross-tonnage">
                    <span className="pc-text-smalllabel reserve-manual-label gross-tonnage-label">Gross Tonnage </span>  
                    { ReadOnly().GrossTonnage 
                     ? <input type="text" value={ReadOnly().GrossTonnage!.Num || ''} disabled={true} /> // TODO: real widget for entering gross tonnage
                     : <input type="text" value={ov.GrossTonnage.Num() || ''} onChange={e => ov.GrossTonnage.Num(+e.currentTarget.value)} placeholder="Required*" /> }
                </div>
                <div className="reserve-manual-row length">
                    <span className="pc-text-smalllabel reserve-manual-label length-label">Length </span>    
                    { ToggleableReadOnlyLength()
                      ? <div className="length-textonly">
                            <ToggleableMeasurementView model={ToggleableReadOnlyLength()!} textonly={true}/>
                        </div>
                      : <div className="length-override">
                            <ToggleableMeasurementView model={ToggleableOverrideLength} textonly={false} placeholder="Required*" />
                        </div> }
                </div>
                <div className="reserve-manual-row beam">
                    <span className="pc-text-smalllabel reserve-manual-label beam-label">Beam </span>
                    { ToggleableReadOnlyBeam()
                      ? <div className="beam-textonly">
                            <ToggleableMeasurementView model={ToggleableReadOnlyBeam()!} textonly={true} />
                        </div>
                      : <div className="beam-override">
                            <ToggleableMeasurementView model={ToggleableOverrideBeam} textonly={false} placeholder="Required*" />
                        </div> }
                </div>
                <div className="reserve-manual-row maxdraft">
                    <span className="pc-text-smalllabel reserve-manual-label maxdraft-label">Max Draft </span>
                    { ToggleableReadOnlyMaxDraft()
                      ? <div className="maxdraft-textonly">
                            <ToggleableMeasurementView model={ToggleableReadOnlyMaxDraft()!} textonly={true} />
                        </div>
                      : <div className="maxdraft-override">
                            <ToggleableMeasurementView model={ToggleableOverrideMaxDraft} textonly={false} />
                        </div> }
                </div>
                <div className="uomselector uom">
                    <ToggleButton onLabel="Feet" offLabel="Meters" checked={UomInFeet} />
                </div>
            </div>
        </div>);


// WEBPACK FOOTER //
// ./apps/portcall/editnewvesseloverrides/view.tsx